import { type ILoggerService, LoggerServiceFactory } from './LoggerService';

export interface IWindowLocationService {
  goto(path: string, navigate?: (path: string) => void): void;
}
export class WindowLocationService implements IWindowLocationService {
  private logger: ILoggerService;
  constructor() {
    this.logger = LoggerServiceFactory.create('WindowLocationService');
  }
  goto(path: string): void {
    this.logger.trace(`Navigate to ${path}`);
    window.location.href = path;
  }
}

export const WindowLocationServiceToken = Symbol(WindowLocationService.name);
